import { render, staticRenderFns } from "./client-roster.vue?vue&type=template&id=c48357e4&scoped=true"
import script from "./client-roster.vue?vue&type=script&lang=js"
export * from "./client-roster.vue?vue&type=script&lang=js"
import style0 from "./client-roster.vue?vue&type=style&index=0&id=c48357e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48357e4",
  null
  
)

export default component.exports